export type Scope =
  | 'personal'
  | 'company:woxom-health'
  | 'company:leadmomentum'
  | 'company:client-link';

export interface ScopeDefinition {
  id: Scope;
  label: string;
  slug: string;
  color: string;
}

export const SCOPES: ScopeDefinition[] = [
  { id: 'personal', label: 'Personal', slug: 'personal', color: '#64748b' },
  { id: 'company:woxom-health', label: 'Woxom Health', slug: 'woxom-health', color: '#0ea5e9' },
  { id: 'company:leadmomentum', label: 'LeadMomentum', slug: 'leadmomentum', color: '#a855f7' },
  { id: 'company:client-link', label: 'Client Link', slug: 'client-link', color: '#22c55e' },
];

export function scopeFromSlug(slug: string | undefined): Scope | null {
  if (!slug) return null;
  if (slug === 'personal') return 'personal';
  const match = SCOPES.find((s) => s.slug === slug);
  return match?.id ?? null;
}

export function scopeToSlug(scope: Scope): string {
  const match = SCOPES.find((s) => s.id === scope);
  return match?.slug ?? 'personal';
}

export function labelForScope(scope: Scope): string {
  return SCOPES.find((s) => s.id === scope)?.label ?? scope;
}
